// extracted by mini-css-extract-plugin
module.exports =  {"link":"_33974c2b58--link--UcFgV"};